export const skills = [
  "JavaScript",
  "TypeScript",
  "React",
  "Next.js",
  "Node",
  "MongoDB",
  "SQL",
  "Tailwind CSS",
  "C/C++",
  "Python",
];
